import React from "react";
import UseContext from "hooks/useContext";
import { InformationIcon, Localisation } from "assets/icons";
import {
    formatHourlyRate,
    formatTemplateCity,
    getTemplateTitle,
} from "pages/missionTemplates/utils/templateListing";

const TemplateCard = ({ template, onPreview }) => {
    const { language } = UseContext();
    if (!template) return null;

    const isBelowMinimumWage = !!template.isBelowMinimumWage;
    const hourlyRate = formatHourlyRate(template.salary?.wage_per_hour);

    const openPreview = () => onPreview?.(template);

    const handleKeyDown = (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        // Space would otherwise scroll the page.
        event.preventDefault();
        openPreview();
    };

    return (
        <div
            role="button"
            tabIndex={0}
            data-template-id={template._id}
            onClick={openPreview}
            onKeyDown={handleKeyDown}
            className={`flex h-full min-w-0 cursor-pointer flex-col rounded-xl border bg-white p-4 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-500 focus-visible:ring-offset-2 ${
                isBelowMinimumWage
                    ? "border-red-300 hover:border-red-400"
                    : "border-gray-200 hover:border-gray-300"
            }`}
        >
            <h3 className="ft-b font-semibold text-gray-900 truncate">
                {getTemplateTitle(template) || "-"}
            </h3>
            <p className="mt-0.5 ft-sm text-gray-500 truncate">
                {template.activity || "-"}
            </p>

            {isBelowMinimumWage && (
                <p className="mt-3 flex items-start gap-1.5 ft-xs text-red-700">
                    <span className="shrink-0" aria-hidden="true">
                        <InformationIcon wh={14} color="#B91C1C" />
                    </span>
                    {language.getValue(
                        "missionTemplate.list.belowMinimumWage",
                        "Sous le SMIC : mettez la fiche à jour avant de créer une mission."
                    )}
                </p>
            )}

            <div className="mt-auto flex items-center justify-between gap-3 pt-7">
                <span className="flex min-w-0 items-center gap-1.5 ft-sm text-gray-500">
                    <span className="shrink-0" aria-hidden="true">
                        <Localisation wh={14} color="#6B7280" />
                    </span>
                    <span className="truncate">
                        {formatTemplateCity(template.location) || "-"}
                    </span>
                </span>
                {hourlyRate && (
                    <span className="shrink-0 ft-sm whitespace-nowrap">
                        <span className="font-semibold text-gray-900">
                            {hourlyRate}
                        </span>
                        <span className="font-light text-gray-500">
                            {" "}
                            {language.getValue(
                                "missionTemplate.list.perHour",
                                "/h"
                            )}
                        </span>
                    </span>
                )}
            </div>
        </div>
    );
};

export default TemplateCard;
